module.exports = __webpack_public_path__ + "static/media/WelcomeRefiveDotOverlay.c011db41.png";